// 开发地址
//  const url = 'http://api.cnzha.com/';

//线上地址
const url = 'http://mt.halopay.cn/api/';


//强哥本地IP
// const url = 'http://192.168.0.124:8080';
// const url = 'http://192.168.0.130:8080';

export default {
  baseUrl: '',
  mtbaseUrl: url,
  login: '/api/app/login',
  verify: '/api/app/sendCode',
  reg:'/api/app/register',
  forgetpass:'/api/app/updatePassword',
  banners: '/api/app/file/getFileByType',
  recGoodsList:'/api/app/goods/recommendGoods',
  hotGoodsList:'/api/app/goods/hotGoods',
  recGoodsListNoUser:'/api/app/goods/recommendNoUserGoods',
  allGoodsList:'/api/app/goods/getAllGoods',
  allGoodsListNoUser:'/api/app/goods/getAllNoUserGoods',
  bonusGoodsList:'/api/app/goods/getBonusGoods',
  sort: '/api/app/goods/getGoodsType',
  serials:'/api/app/goods/getGoodsSecondType',
  serialGoods:'/api/app/goods/getGoodsByTypeId',
  userinfo:'/api/app/user/userInfo',
  comments: '/api/app/appraises/getUserAppraises',
  addAppraises:'/api/app/appraises/add',
  getGoodsAppraises:'/api/app/appraises/getAppraises',
  updateUserInfo:'/api/app/user/update',
  accountList:'/api/app/account/list',
  deleteAccount:'/api/app/account/delete',
  addAliPay:'/api/app/account/addAliPay',
  addCard:'/api/app/account/addCard',
  updateUserPass:'/api/app/updateUserPassword',
  updatePayPass:'/api/app/updatePayPassword',
  setupPayPassword:'/api/app/setUpPayPassword',
  getBonus:'/api/app/account/getBonus',
  groups:'/api/app/achievememt/groups', //------------------查询团队接口
  expInfo:'/api/app/order/expInfo',
  addressList:'/api/app/userAds/getAdsList',
  addAddress:'/api/app/userAds/save',
  updateAddress:'/api/app/userAds/update',
  deleteAddress: '/api/app/userAds/delete',
  orderList:'/api/app/order/list',
  getGoodsByGoodsNum:'/api/app/goods/getGoodsByGoodsNum',
  getSku:'/api/app/goodsDetailType/getSku',
  getOrderByOrderNum:'/api/app/order/getOrderByOrderNum',
  getOrderNumByOrderId:'/api/app/order/getOrderNumByOrderId',
  cancelOrder:'/api/app/order/cancelOrder',
  transBonus:'/api/app/account/largessBounds',
  mobileUser:'/api/app/user/selectByMobile',
  scoreRecord:'/api/app/account/convertDetail',
  convertBounds:'/api/app/account/convertBounds',
  scoreDetail:'/api/app/account/getScoreDetailById',
  typescorelist:'/api/app/account/getOrderScoreListByType',
  share:'/api/app/share/info',
  shareList:'/api/app/share/list',
  addCart:'/api/app/cart/saveOrUpdate',
  getCartInfo:'/api/app/cart/getCartInfo',
  // getGroupingInfo:'/api/v1/acco/getGroupingInfo',
  getGroupingInfo:'/api/app/activity/getGroupingInfo',
  getGroupingInfoOne:'/api/app/activity/getGroupingInfoOne',
  updateGroupInfo:'/api/app/activity/updateGroupInfo/',
  getGroupingJoinInfo:'/api/app/activity/getGroupingJoinInfo/',
  shopCart:'/api/app/cart/list',
  deleteCart:'/api/app/cart/delete',
  friends: '/api/app/user/selectByParentId',
  refundApply: '/api/app/order/refundApply',
  refundList: '/api/app/order/refundApplyList',
  notification:'/api/app/notification/list',
  searchList:'/api/app/goods/selectGoodsByLike',
  orderReceipt:'/api/app/order/receipt',
  bankList:'/api/app/account/getBankList',
  newsList:'/api/app/news/list',
  newsDetailById:'/api/app/news/info/',
  orderSave:'/api/app/order/save',
  getDefaultAddress:'/api/app/userAds/getAdsByDefaultFlag',
  pointPay:'/api/app/pay/pointPay',
  wxPay:'/api/app/pay/wxPay',
  payResult:'/api/app/order/getById',
  getUserInfoById:'/api/app/user/userShareInfo',
  getFileByType:'/api/app/file/getFileByType',
  orderPaySucc:'/api/app/order/getById',
  orderPaySuccNew:'/api/app/yspay/getResult',
  returnReason:'/api/app/order/returnReasonList',
  defaultAddress: '/api/app/userAds/updateDefaultFlag',
  wxJsPay:'/api/app/pay/wxJsPay',
  addressAndGoods:'/api/app/userAds/getAdsListAndGoods',
  getCartGroupId:'/api/app/cart/getCartGroupId',
  getCartGroupInfo:'/api/app/cart/getCartGroupInfo',
  wxAuth:'/api/app/wx/authorization?userId=',
  wxConfig:'/api/app/share/getWxConfig',
  feedback:'/api/app/feedback/save',
  newsDetail: '/api/app/file/getFileByForeignId',
  getAllSerials: '/api/app/goods/getGoodsSecondType',
  aliPay: '/api/app/pay/aliPay',
  shareGoods: '/api/app/share/shareGoods/',
  getPostageInfo: '/api/app/order/postageInfo',
  wxJsPayNew:'/api/app/yspay/wxJsPayNew',
}



// WEBPACK FOOTER //
// ./src/http/url.js